module.exports = __webpack_public_path__ + "img/icon_facebook.1cb5218f.svg";